import Chip from "@mui/material/Chip";

// Situação de revisão das Formações e Instituições de Ensino (ambas no
// feminino). Os itens revisados aparecem primeiro nas listas de seleção
// do cadastro do sócio (a API ordena por "revisado").
export const ReviewedChip = ({ reviewed }: { reviewed?: boolean | null }) => (
  <Chip
    size="small"
    variant="outlined"
    color={reviewed ? "success" : "default"}
    label={reviewed ? "Revisada" : "Não revisada"}
  />
);

// Opções do filtro "Revisão" das listas (a API compara com o texto
// "true"; qualquer outro valor vira "não revisada")
export const reviewedFilterChoices = [
  { id: "true", name: "Revisadas" },
  { id: "false", name: "Não revisadas" },
];
